import { render } from "./InputHorizontal.vue?vue&type=template&id=ef9a88f4"
import script from "./InputHorizontal.vue?vue&type=script&lang=js"
export * from "./InputHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__